'use client';

import { isAndroid } from 'react-device-detect';
import { isNativeAppBoth } from '@wconcept/wconcept-common/utils/userAgentUtil';

import {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { getDeviceName } from '@utils/deviceUtil';

interface IProps {
  children?: React.ReactNode;
}

interface IAppState {
  isHeaderExpanded?: boolean;
}

const AppStateContext = createContext<IAppState>({
  isHeaderExpanded: undefined,
});

function AppStateProvider({ children }: IProps) {
  const [appState, setAppState] = useState<IAppState>({
    isHeaderExpanded: undefined,
  });

  const getPushAllow = useCallback(() => {
    window.wckAppStateFunction.isHeaderExpanded = function (value) {
      setAppState(prevState => ({ ...prevState, isHeaderExpanded: value }));
    };
    try {
      window.location.href =
        'wconceptkr://isHeaderExpanded?callback=wckAppStateFunction.isHeaderExpanded';
    } catch (error) {
      console.error(error);
    }
  }, []);

  const handleTouchEnd = () => {
    // eslint-disable-next-line prefer-destructuring
    const userAgent = window.navigator.userAgent;
    const deviceName = getDeviceName(userAgent);
    const isNativeAppBothValue = isNativeAppBoth(userAgent);
    if (deviceName === 'Android' && isNativeAppBothValue) {
      getPushAllow();
    }
  };

  const getVideoStatus = useCallback(() => {
    window.wckAppStateFunction.getVideoStatus = () => {};
  }, []);

  useEffect(() => {
    window.wckAppStateFunction = {};
    const isNativeAppBothValue = isNativeAppBoth(window.navigator.userAgent);
    if (isNativeAppBothValue) {
      getVideoStatus();
    }
    if (isAndroid && isNativeAppBothValue) {
      getPushAllow();
    }

    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return (
    <AppStateContext.Provider value={appState}>
      {children}
    </AppStateContext.Provider>
  );
}

export { AppStateProvider, AppStateContext };
